module.exports = __webpack_public_path__ + "img/img11.8b239b79.png";